import React from "react";
import { Box, Tooltip } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockOutlineIcon from "@mui/icons-material/LockOutline";
import ErrorIcon from "@mui/icons-material/Error";
import { TEligibility } from "../../../../../features/productAnalyzer/productAnalyzer.types";
import { colors } from "../../config";

interface EligibilityProps {
  eligibility?: TEligibility;
}

const Eligibility: React.FC<EligibilityProps> = ({ eligibility }) => {
  const eligible = eligibility?.eligible;

  const getStyles = () => {
    if (eligible === "Yes") {
      return {
        backgroundColor: colors.background.gray, // Gray background
        iconColor: colors.success.icon, // Green icon
        IconComponent: LockOpenIcon,
      };
    } else if (eligible === "No") {
      return {
        backgroundColor: colors.background.gray, // Gray background
        iconColor: colors.error.input, // Red icon
        IconComponent: LockOutlineIcon,
      };
    } else if (eligible === "Not Connected" || eligible === "Unknown") {
      return {
        backgroundColor: colors.background.gray, // Gray background
        iconColor: "rgb(189, 189, 189)", // Gray icon
        IconComponent: ErrorIcon,
      };
    }
    return null;
  };

  const styles = getStyles();
  const IconComponent = styles?.IconComponent;

  if (!styles || !IconComponent) {
    return null;
  }

  return (
    <Tooltip
      title={
        eligibility?.hint ? (
          <div
            dangerouslySetInnerHTML={{
              __html: eligibility.hint,
            }}
          ></div>
        ) : null
      }
      arrow
    >
      <Box
        sx={{
          width: "25px",
          height: "25px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4px",
          backgroundColor: styles.backgroundColor,
        }}
      >
        <IconComponent
          sx={{
            fontSize: "16px",
            color: styles.iconColor,
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default Eligibility;
